import { render } from "./ContainerReeferDetails.vue?vue&type=template&id=0b008895&ts=true"
import script from "./ContainerReeferDetails.vue?vue&type=script&lang=ts"
export * from "./ContainerReeferDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__